import React from 'react';
import { Box, PageNotice } from '@usealloy/component-library';

type MessageWrapperProps = {
  children: JSX.Element;
  status?: 'info' | 'danger';
};

export function MessageWrapper({
  children,
  status = 'danger',
}: MessageWrapperProps) {
  return (
    <PageNotice data-testid="customer-access-message-wrapper" status={status}>
      <Box
        style={{ paddingLeft: '16px', paddingRight: '16px' }}
        direction="row"
        gap={2}
      >
        {children}
      </Box>
    </PageNotice>
  );
}
